import { createFileRoute } from "@tanstack/react-router";
import { PurchaseAnalysisIndexPurchasesPage } from "@/features/reports/purchase-analysis-index-purchases-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/analiza-zakupy-indeksow")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.analiza-zakupy-indeksow",
			location.pathname,
		);
	},
	component: PurchaseAnalysisIndexPurchasesPage,
});
